import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { ApiClient, useApiClient } from 'api/context-provider/useApiClient';
import { throwOnError } from 'api/helpers';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

async function getB2CVerificationRequestQuery(apiClient: ApiClient, id: string | undefined) {
  return apiClient.GET(`/op/v2/b2c-verification/{id}`, {
    params: { path: { id: id! } },
  });
}

export default function useB2CVerificationRequestQuery(id: string | undefined) {
  const toast = useToast();
  const apiClient = useApiClient();

  const query = useQuery({
    queryKey: getKey(id),
    queryFn: () => throwOnError(getB2CVerificationRequestQuery(apiClient, id)),
    enabled: !!id,
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, query.error as any);
    }
  }, [query.error, query.isError, toast]);
  return query;
}

function getKey(id: string | undefined): QueryKey {
  return ['B2CVerificationRequest', id] as const satisfies QueryKey;
}

useB2CVerificationRequestQuery.getKey = getKey;
